export default {
    "labels": {
        "labels": "Labels",
        "publicLabels": "Public Labels",
        "privateLabels": "Private Labels",
        "public": "Public",
        "private": "Private",
        "selectLabel": "Select label(s)",
        "deleteLabelAreYouSure": "Are you sure you want to remove the label: {name}?",
        "bulkAddLabelAreYouSure": "Are you sure you want to bulk add the label: {name} to the results of the current query?",
        "bulkRemoveLabelAreYouSure": "Are you sure you want to bulk remove the label: {name} to the results of the current query?",
        "addPublicLabelText": "+",
        "removePublicLabelText": "×",
        "addPublicLabelTitle": "Add public label",
        "selectPublicLabelTitle": "Select public label",
        "removePublicLabelTitle": "Remove public label",
        "addPrivateLabelText": "+",
        "removePrivateLabelText": "×",
        "addPrivateLabelTitle": "Add private label",
        "selectPrivateLabelTitle": "Select private label",
        "removePrivateLabelTitle": "Remove private label"
    },

    "renameLabel": {
        "title": "Rename Label(s) globally",
        "btnRename": "Rename",
        "newLabel": "New Label",
        "oldLabels": "Old label(s)",
        "alertText": "This action renames the label(s) in the index and is irreversible",
        "successFeedback": "Label(s) renamed in the index",
        "errorFeedback": "An error occurred. Request failed"
    },

    "deleteLabel": {
        "title": "Delete label(s) globally",
        "btnDelete": "Delete",
        "alertText": "This action deletes the selected label(s) from the index and is irreversible",
        "successFeedback": "Label(s) deleted from the index",
        "errorFeedback": "An error occurred. Request failed"
    },

    "bulkRemoveLabel": {
        "title": "Remove label(s) from the current results",
        "btnBulkRemove": "Remove",
        "alertText": "This action removes the selected label(s) from all results reported by the engine (not only from the first page)",
        "successFeedback": "Label(s) removed from all results reported by the engine",
        "errorFeedback": "An error occurred. Request failed"
    },

    "bulkAddLabel": {
        "title": "Add label(s) to the current results",
        "btnBulkAdd": "Add",
        "alertText": "This action assigns the selected label(s) to all results reported by the engine (not only to the first page)",
        "infoText": "Press 'Enter' to add a new label that does not exist in the suggestions",
        "successFeedback": "Label(s) assigned to all results reported by the engine",
        "errorFeedback": "An error occurred. Request failed"
    },

    "editLabel": {
        "title": "Edit the label(s) of the selected result(s)",
        "btnEdit": "Save",
        "alertText": "This action edits the label(s) of the selected result(s)",
        "infoText": "Press 'Enter' to add a new label that does not exist in the suggestions",
        "labelsToBeRemoved": "Label(s) to be removed",
        "labelsToBeAdded": "Label(s) to be added",
        "successFeedback": "Label(s) of the selected result(s) edited",
        "errorFeedback": "An error occurred. Request failed"
    }

};
